import { motion } from 'framer-motion';
import { Check } from 'lucide-react';

import { Card } from '@/components/ui/card';

import { ExtractionCardProps } from '../types';

export function PipelineExtractionCard({
    data,
    progress,
    documents,
}: ExtractionCardProps) {
    const isLoading = progress?.extracting === 'loading';
    const isComplete = progress?.extracting === 'complete';
    const document = documents.find((d) => d.id === data.id);

    return (
        <Card className="p-4 min-h-[150px]">
            {isLoading ? (
                <div className="space-y-2">
                    <div className="flex items-center gap-2 mb-2">
                        <span className="text-xs font-semibold px-2 py-0.5 bg-muted rounded">
                            Doc {data.id}
                        </span>
                        {document && (
                            <span className="text-xs font-semibold px-2 py-0.5 bg-blue-100 text-blue-700 rounded">
                                {document.type}
                            </span>
                        )}
                    </div>
                    <div className="h-3 bg-muted rounded animate-pulse" />
                    <div className="h-3 bg-muted rounded w-3/4 animate-pulse" />
                    <div className="h-3 bg-muted rounded w-1/2 animate-pulse" />
                </div>
            ) : isComplete ? (
                <div className="space-y-2">
                    <div className="flex items-start justify-between gap-2">
                        <div className="space-y-1.5 flex-1 min-w-0">
                            <div className="flex items-center gap-2 mb-1">
                                <span className="text-xs font-semibold px-2 py-0.5 bg-muted rounded">
                                    Doc {data.id}
                                </span>
                                {document && (
                                    <span className="text-xs font-semibold px-2 py-0.5 bg-blue-100 text-blue-700 rounded">
                                        {document.type}
                                    </span>
                                )}
                            </div>
                            <div className="text-sm font-semibold">
                                {data.partNumber}
                            </div>
                            <div className="text-xs text-muted-foreground mt-2">
                                Serial:{' '}
                                <span className="font-medium text-foreground">
                                    {data.serial}
                                </span>
                            </div>
                            <div className="text-xs text-muted-foreground">
                                Date:{' '}
                                <span className="font-medium text-foreground">
                                    {data.date}
                                </span>
                            </div>
                        </div>
                        <motion.div
                            initial={{ scale: 0 }}
                            animate={{ scale: 1 }}
                            transition={{
                                type: 'spring',
                                stiffness: 500,
                                damping: 30,
                            }}
                            className="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0"
                        >
                            <Check className="w-3.5 h-3.5 text-green-600" />
                        </motion.div>
                    </div>
                </div>
            ) : null}
        </Card>
    );
}
